import { PayloadAction } from '@reduxjs/toolkit';
import { ActionTypes } from './firebaseConfig';
import { FirebaseState } from './firebaseInterface';

const initialState: FirebaseState = {
    error: undefined
};
const reducer = (state: FirebaseState, action: PayloadAction<any>): FirebaseState => {
    const { type, payload } = action;
    switch (type) {
	
        case ActionTypes.FB_IS_updateIndicator:
            return {
                ...state,
                isFirebaseInitialized: !!payload,
                error: undefined
            };
        default:
            return { ...initialState, ...state };
    }
};

export default reducer;
